import _get from "lodash/get";

import { Controller } from "stimulus";

export default class extends Controller {
  get editorErrorsNotice() {
    return document.getElementById("editor-errors");
  }

  // Get Flash DOM element
  get flashElem() {
    return document.getElementById("paris-flash");
  }

  // Get Flash controller
  get flash() {
    return this.application.getControllerForElementAndIdentifier(
      this.flashElem,
      "flash"
    );
  }

  // Get controller associated to element with the specific identifier
  getControllerForIdentifierContainingElement(identifier, element) {
    if (!element || typeof element.closest !== "function") {
      throw new Error("Missing DOM element");
    }

    const controllerElement = element.closest(
      `[${this.application.schema.controllerAttribute}~="${identifier}"]`
    );

    return this.application.getControllerForElementAndIdentifier(
      controllerElement,
      identifier
    );
  }

  // Get content attribute of a meta tag identified by its name
  getMetaContent(name) {
    return _get(document.head.querySelector(`meta[name="${name}"]`), "content");
  }
}
